import * as React from 'react'

import { Box, TagColor as Color, Tag } from '@factorialco/deprecated-design-system'
import { PerformanceReviewEvaluationStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { tagColor } from 'modules/performance_process/lib/answerTag'

interface Props {
  evaluationsConnection_totalCount: number
  publishedEvaluationsConnection_totalCount: number
}

const getStatusInfo = (
  evaluationStatus: PerformanceReviewEvaluationStatusEnum
): { color: Color; label: string } => {
  switch (evaluationStatus) {
    case 'pending':
      return {
        color: Color.grey,
        label: i18n.t('performance_process.reviews.target_datatable.results.pending'),
      }
    case 'published':
      return {
        color: Color.correct,
        label: i18n.t('performance_process.reviews.target_datatable.results.published'),
      }
  }
}

const tagLabel = (evaluationStatus: PerformanceReviewEvaluationStatusEnum) => {
  const statusInfo = getStatusInfo(evaluationStatus)
  return statusInfo.label
}

export const TargetEvaluationsStatusTag = ({
  evaluationsConnection_totalCount,
  publishedEvaluationsConnection_totalCount,
}: Props) => {
  const status =
    publishedEvaluationsConnection_totalCount === evaluationsConnection_totalCount &&
    evaluationsConnection_totalCount != 0
      ? 'published'
      : 'pending'
  return (
    <Box>
      <Tag leftItem="circle" inline capitalize type={tagColor(status)}>
        {tagLabel(status)}
      </Tag>
    </Box>
  )
}
